import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { InvoiceRoutingModule } from './invoice-routing.module';
import { NewInvoiceComponent } from './new-invoice/new-invoice.component';
import { ListInvoiceComponent } from './list-invoice/list-invoice.component';
import { AppMaterialModule } from '../app-material/app-material.module';
import { FormsModule } from '@angular/forms';
import { ViewInvoiceComponent } from './view-invoice/view-invoice.component';
import { Safe } from '../_helpers/safe';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';

@NgModule({
  imports: [
    CommonModule,
    InvoiceRoutingModule,
    AppMaterialModule,
    FormsModule,
    NgxDaterangepickerMd.forRoot()
  ],
  declarations: [NewInvoiceComponent, ListInvoiceComponent, ViewInvoiceComponent, Safe],
  providers: []
})
export class InvoiceModule { }
